import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrTag, { SR_TAG_THEMES } from 'client/components/SrTag/SrTag';

import './SrInfoOptionCheckbox.less';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';

/* eslint-disable max-len */
export const SR_INFO_OPTION_CHECKBOX_THEME_ADOBE_BOLD = 'SR_INFO_OPTION_CHECKBOX_THEME_ADOBE_BOLD';
export const SR_INFO_OPTION_CHECKBOX_THEME_ADOBE_UP = 'SR_INFO_OPTION_CHECKBOX_THEME_ADOBE_UP';
export const SR_INFO_OPTION_CHECKBOX_THEME_ADOBE_UP_INVERTED =
  'SR_INFO_OPTION_CHECKBOX_THEME_ADOBE_UP_INVERTED';
/* eslint-enable max-len */

export const SR_INFO_OPTION_CHECKBOX_THEME_TO_CLASSNAME_MAPPING = {
  [SR_INFO_OPTION_CHECKBOX_THEME_ADOBE_BOLD]: 'themeAdobeBold',
  [SR_INFO_OPTION_CHECKBOX_THEME_ADOBE_UP]: 'themeAdobeUp',
  [SR_INFO_OPTION_CHECKBOX_THEME_ADOBE_UP_INVERTED]: 'themeAdobeUpInverted',
};
export const SR_INFO_OPTION_CHECKBOX_THEMES = Object.keys(
  SR_INFO_OPTION_CHECKBOX_THEME_TO_CLASSNAME_MAPPING,
);

const SrInfoOptionCheckbox = ({
  isActive,
  theme,
  tagTheme,
  title,
  subtitle,
  tagContents,
  onClick,
  description,
  collapseUnselected,
  disabled = false,
  footer,
  sublabel,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const getThemeActiveIcon = () => {
    switch (theme) {
      case SR_INFO_OPTION_CHECKBOX_THEME_ADOBE_UP_INVERTED:
        return '/images/checkmark-circle-orange.svg';
      case SR_INFO_OPTION_CHECKBOX_THEME_ADOBE_BOLD:
      case SR_INFO_OPTION_CHECKBOX_THEME_ADOBE_UP:
      default:
        return '/images/checkmark-circle-green.svg';
    }
  };

  const activeIcon = getThemeActiveIcon();

  const onClickHandler = () => {
    if (disabled) {
      return;
    }
    return onClick();
  };

  return (
    <div
      styleName={classnames(
        'containerWrapper',
        { isActive },
        SR_INFO_OPTION_CHECKBOX_THEME_TO_CLASSNAME_MAPPING[theme],
      )}
    >
      <div onClick={onClickHandler} styleName={classnames('container', { disabled })}>
        <SrFlex justify="between" align="center" flex={1}>
          <SrFlex align="center">
            <img
              styleName="checkboxIcon"
              alt="checkbox icon"
              src={isActive ? activeIcon : '/images/circle-small-grey.svg'}
            />
            <div styleName="titleContainer">
              <SrText
                color="blueGreycliff"
                font="greycliff"
                fontSize="18px"
                lineHeight="22px"
                weight="800"
              >
                {title}
              </SrText>
            </div>
            {sublabel && (
              <div>
                <SrText
                  color="blueGreycliff"
                  font="greycliff"
                  fontSize="13px"
                  lineHeight="18px"
                  weight="600"
                >
                  {sublabel}
                </SrText>
              </div>
            )}
          </SrFlex>
          {tagContents && <SrTag theme={tagTheme}>{tagContents}</SrTag>}
        </SrFlex>
        {subtitle && (
          <div styleName="subtitleContainer">
            <span styleName="subtitleText">{subtitle}</span>
          </div>
        )}
        {(!collapseUnselected || isActive) && description && (
          <SrBox
            marginTop="6px"
            marginBottom="10px"
            maxWidth={isSmallScreen ? null : 'calc(100% - 160px)'}
          >
            <SrText
              display="block"
              font="greycliff"
              color="blueGreycliff"
              fontSize="13px"
              lineHeight="18px"
              weight="600"
            >
              {description}
            </SrText>
          </SrBox>
        )}
      </div>
      {footer && <div styleName="footer">{footer}</div>}
    </div>
  );
};

SrInfoOptionCheckbox.propTypes = {
  isActive: PropTypes.bool,
  tagContents: PropTypes.string,
  tagTheme: PropTypes.oneOf(SR_TAG_THEMES),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  sublabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  theme: PropTypes.oneOf(SR_INFO_OPTION_CHECKBOX_THEMES),
  onClick: PropTypes.func,
  description: PropTypes.string,
  collapseUnselected: PropTypes.bool,
  footer: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

SrInfoOptionCheckbox.defaultProps = {
  theme: SR_INFO_OPTION_CHECKBOX_THEME_ADOBE_BOLD,
};

SrInfoOptionCheckbox.displayName = 'SrInfoOptionCheckbox';

export default SrInfoOptionCheckbox;
